module.exports = __webpack_public_path__ + "img/08.0dec6271.png";